<template>
  <v-card>
    <v-toolbar
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title class="white--text">Modifica Barche</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaModificaBarca" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva Modifica</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chiudiDialog" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row align="center" justify="center">
          <!-- Colonna del Nome Barca -->
          <v-col cols="3" dense>
            <v-text-field
              dense
              hide-details
              v-model="barca_sel_tmp.des_macchina"
              label="Nome Barca"
            ></v-text-field>
          </v-col>

          <!-- Colonna del modello e num. scafo -->
          <v-col cols="3" dense>
            <v-text-field
              dense
              hide-details
              v-model="barca_sel_tmp.modello"
              label="Modello e Num. Scafo"
            ></v-text-field>
          </v-col>

          <!-- Colonna della matricola HIN -->
          <v-col cols="3" dense>
            <v-text-field
              dense
              hide-details
              v-model="barca_sel_tmp.matricola"
              label="Matricola HIN"
            ></v-text-field>
          </v-col>

          <!-- Colonna della marca -->
          <v-col cols="3" dense>
            <v-text-field
              dense
              hide-details
              v-model="barca_sel_tmp.marca"
              label="Marca"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <!-- Colonna della Zona Geografica -->
          <v-col cols="3">
            <v-autocomplete
              @change="associaDesReparto"
              dense
              hide-details
              :items="items_reparto"
              item-text="des"
              item-value="id_tabella"
              v-model="barca_sel_tmp.id_reparto"
            >
              <template #label>
                <span class="">Zona Geografica</span>
                <a @click.stop style="pointer-events: all">
                  <Modules
                    v-on:dialogModules="gettabelle"
                    tipo="MACCHINA_REPARTO"
                    nome="Zone Geografiche"
                    setaction="settabelle"
                    getaction="gettabelle"
                    controller="Magazzino"
                    filter="validita = 1"
                    :dati="[{ des: '' }]"
                  />
                </a>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3" dense>
            <v-menu
              v-model="calendario_inizio_garanzia"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  background-color="#ffffff"
                  dense
                  hide-details
                  label="Inizio Garanzia Cantiere"
                  v-model="inizio_garanzia_formattata"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="barca_sel_tmp.inizio_garanzia"
                @input="calendario_inizio_garanzia = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" dense>
            <v-menu
              v-model="calendario_fine_garanzia"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  background-color="#ffffff"
                  dense
                  hide-details
                  label="Fine Garanzia Cantiere"
                  v-model="fine_garanzia_formattata"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                @input="calendario_fine_garanzia = false"
                :min="barca_sel_tmp.inizio_garanzia"
                v-model="barca_sel_tmp.fine_garanzia"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" dense>
            <v-menu
              v-model="calendario_data_consegna"
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="289"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  background-color="#ffffff"
                  dense
                  hide-details
                  label="Fine Ns. Garanzia"
                  v-model="data_acquisto_formattata"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="barca_sel_tmp.data_acquisto"
                @input="calendario_data_consegna = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <!-- Sezione dedicata al progetto -->
      <v-toolbar class="mt-5" color="indigo" dense>
        <v-toolbar-title class="white--text">
          Dati di Progetto
        </v-toolbar-title>
      </v-toolbar>
      <v-container class="mt-n4" fluid>
        <v-row align="center" justify="center">
          <v-col cols="3" dense>
            <v-autocomplete
              dense
              hide-details
              :items="items_stati_progetto"
              item-text="des"
              item-value="id_tabella"
              label="Stato"
              v-model="barca_sel_tmp.progetto[0].stato"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" dense>
            <v-autocomplete
              dense
              hide-details
              :items="items_tipi_progetto"
              item-text="des"
              item-value="id_tabella"
              label="Tipo"
              v-model="barca_sel_tmp.progetto[0].tipo_progetto"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" dense>
            <v-autocomplete
              dense
              hide-details
              :items="items_committenti"
              item-text="ragione_sociale"
              item-value="id_anagrafica"
              label="Committente"
              v-model="barca_sel_tmp.progetto[0].committente"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3" dense>
            <v-checkbox
              :false-value="0"
              label="Attivato"
              v-model="barca_sel_tmp.progetto[0].attivato"
              :true-value="1"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ModificaBarca",
  components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
  },
  props: {
    barca_sel: {
      type: Object,
      default: () => {},
    },
    des_usate: {
      type: Array,
      default: () => [],
    },
    flagEM: {
      type: Boolean,
      default: false,
    },
    id_filtro_nave: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      barca_sel_tmp: {},

      // Modal
      calendario_data_consegna: false,
      calendario_fine_garanzia: false,
      calendario_inizio_garanzia: false,
      overlay: false,

      // Array
      items_committenti: new Array(),
      items_reparto: new Array(),
      items_stati_progetto: new Array(),
      items_tipi_progetto: new Array(),
    };
  },
  computed: {
    data_acquisto_formattata() {
      return this.barca_sel_tmp.data_acquisto != ""
        ? moment(this.barca_sel_tmp.data_acquisto).format("DD/MM/YYYY")
        : "";
    },
    fine_garanzia_formattata() {
      return this.barca_sel_tmp.fine_garanzia != ""
        ? moment(this.barca_sel_tmp.fine_garanzia).format("DD/MM/YYYY")
        : "";
    },
    inizio_garanzia_formattata() {
      return this.barca_sel_tmp.inizio_garanzia != ""
        ? moment(this.barca_sel_tmp.inizio_garanzia).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.barca_sel_tmp = Object.assign({}, this.barca_sel);
        }
      },
    },
  },
  methods: {
    associaDesReparto() {
      this.items_reparto.forEach((e) => {
        if (e.id_tabella === this.barca_sel_tmp.id_reparto) {
          this.barca_sel_tmp.des_reparto = e.des;
        }
      });
    },
    chiudiDialog() {
      this.$emit("chiudi_dialog");
    },
    getCommittenti() {
      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api6", request).then((res) => {
        this.items_committenti = res.data.result.lista;
      });
    },
    gettabelle() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'MACCHINA_REPARTO','TIPO_PROGETTO','STATO_DOCUMENTO'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.items_reparto = res.data.MACCHINA_REPARTO
          ? res.data.MACCHINA_REPARTO
          : [];
        this.items_tipi_progetto = res.data.TIPO_PROGETTO
          ? res.data.TIPO_PROGETTO
          : [];
        this.items_stati_progetto = res.data.STATO_DOCUMENTO
          ? res.data.STATO_DOCUMENTO
          : [];
      });
    },
    salvaModificaBarca() {
      /* Eseguo una serie di controlli per essere sicuro che
       * la request che invio al BE sia ben formata. */

      // Controllo che i campi siano valorizzati
      if (this.barca_sel_tmp.des_macchina === "") {
        this.barca_sel_tmp.des_macchina = "Nome N/D";
      }

      // Per convenienza di BE sostituisco gli apostrofi
      if (this.barca_sel_tmp.des_macchina.includes("'")) {
        this.barca_sel_tmp.des_macchina =
          this.barca_sel_tmp.des_macchina.replace("'", "‘");
      }

      if (this.barca_sel_tmp.marca === "") {
        this.barca_sel_tmp.marca = "Marca N/D";
      }

      if (this.barca_sel_tmp.matricola === "") {
        this.barca_sel_tmp.matricola = "Matricola N/D";
      }

      if (this.barca_sel_tmp.modello === "") {
        this.barca_sel_tmp.modello = "Modello N/D";
      }

      // Controllo che i campi non siano uguali fra loro
      if (
        this.barca_sel_tmp.marca === this.barca_sel_tmp.matricola ||
        this.barca_sel_tmp.marca === this.barca_sel_tmp.modello
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I campi Marca, Matricola e Modello non possono avere gli stessi valori."
        );
        return;
      }
      if (
        this.barca_sel_tmp.matricola === this.barca_sel_tmp.marca ||
        this.barca_sel_tmp.matricola === this.barca_sel_tmp.modello
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I campi Marca, Matricola e Modello non possono avere gli stessi valori."
        );
        return;
      }
      if (
        this.barca_sel_tmp.des_macchina === this.barca_sel_tmp.marca ||
        this.barca_sel_tmp.des_macchina === this.barca_sel_tmp.matricola ||
        this.barca_sel_tmp.des_macchina === this.barca_sel_tmp.modello
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La descrizione non può essere uguale al campo Marca, Matricola o Modello."
        );
        return;
      }

      // Controllo che la des_macchina non sia già stata usata se sono su EM.
      let chk_des = true;
      this.des_usate.forEach((e) => {
        if (
          e === this.barca_sel_tmp.des_macchina &&
          this.barca_sel_tmp.id_macchinam === -1
        ) {
          chk_des = false;
        }
      });

      if (chk_des === false && this.flagEM === true) {
        this.$refs.SnackbarQV.print(
          "Orange",
          "Il nome barca è già stato usato."
        );
        return;
      }

      // Preparo la request di salvataggio

      // Faccio in modo che la macchina sia segnata come nave.
      this.barca_sel_tmp.id_tipo_get_macchina = this.id_filtro_nave;

      const dataarray = [];
      dataarray.push(Object.assign({}, this.barca_sel_tmp));

      /* Se c'è un progetto in dataarray, lo
       * cancello perché non mi serve lì. */
      if (dataarray[0] && dataarray[0].progetto) {
        delete dataarray[0].progetto;
      }

      /* Se c'è un progetto, gli assegno codice
       * e descrizione come mi conviene. */
      if(this.barca_sel_tmp.progetto[0]){
        this.barca_sel_tmp.progetto[0].codice = this.barca_sel_tmp.matricola;
        this.barca_sel_tmp.progetto[0].des_progetto = this.barca_sel_tmp.modello;
      }

      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "updatemacchina",
          token: localStorage.getItem("user_token"),
          tabella: dataarray,
          progetto: [this.barca_sel_tmp.progetto[0]],
          genera_articolo: 1,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            let updatenavi = {
              controller: "Manutenzione",
              method: "POST",
              richiesta: {
                action: "updatenavi",
                token: localStorage.getItem("user_token"),
              },
            };

            this.$store
              .dispatch("api", updatenavi)
              .then((res2) => {
                if (res2.status === 200) {
                  /* Se anche updatenavi è andato in 200 faccio un updatetabellabarche
                   * per aggiornare le zone di default sull'ultima barca aggiunta. */
                  let updatetabellabarche = {
                    controller: "Manutenzione",
                    method: "PUT",
                    richiesta: {
                      action: "updatetabellabarche",
                      token: localStorage.getItem("user_token"),
                      id_macchina: this.barca_sel_tmp.id_macchina,
                      causale:
                        this.barca_sel_tmp.id_macchina === -1
                          ? "new"
                          : "update",
                    },
                  };
                  this.$store
                    .dispatch("api", updatetabellabarche)
                    .then((res3) => {
                      this.overlay = false;
                      if (res3.status === 200) {
                        /* Se la chiamata BE è andata a buon fine
                         * posso emettere l'evento che aggiorna il componente. */
                        this.$emit("salvata_macchina");
                      } else {
                        this.$refs.SnackbarQV.print(
                          "orange",
                          `Si è verificata una criticità tecnica con codice ${res3.status}, non è stato possibile caricare i dati.`
                        );
                      }
                    })
                    .catch((err) => {
                      this.overlay = false;
                      if (err) {
                        // Se ricevo un errore avviso l'Utente con una snackbar.
                        this.$refs.SnackbarQV.print(
                          "error",
                          `Si è verificata una criticità tecnica con codice ${res2.status}, non è stato possibile caricare i dati.`
                        );
                      }
                    });
                } else {
                  this.overlay = false;
                  // Se ricevo un errore avviso l'Utente con una snackbar.
                  this.$refs.SnackbarQV.print(
                    "orange",
                    `Si è verificata una criticità tecnica con codice ${res2.status}, non è stato possibile caricare i dati.`
                  );
                }
              })
              .catch((err) => {
                this.overlay = false;
                if (err) {
                  this.$refs.SnackbarQV.print(
                    "orange",
                    `Errore nello scambio di dati col server, non è stato possibile caricare i dati.`
                  );
                }
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore nello scambio di dati col server, non è stato possibile caricare i dati.`
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          if (err) {
            // Se ricevo un errore avviso l'Utente con una snackbar.
            this.$refs.SnackbarQV.print(
              "error",
              `Errore di comunicazione col server, non è stato possibile salvare i dati.`
            );
          }
        });
    },
  },
  created() {},
  mounted() {
    this.gettabelle();
    this.getCommittenti();
  },
};
</script>

<style scoped>
</style>